import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

/**
 * Toggle "Comunidade": alterna entre o Feed social (/feed) e o Fórum (/forum).
 * Standalone — importado tanto no SocialFeedModule quanto no ForumModule.
 */
@Component({
  selector: 'app-community-tabs',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="ct-wrap">
      <div class="ct-switch">
        <!-- Feed social e forum desativados.
        <a
          routerLink="/feed"
          routerLinkActive="ct-tab--active"
          [routerLinkActiveOptions]="{ exact: false }"
          class="ct-tab"
        >
          <i class="pi pi-images"></i>
          <span>Feed</span>
        </a>
        <a
          routerLink="/forum"
          routerLinkActive="ct-tab--active"
          class="ct-tab"
        >
          <i class="pi pi-comments"></i>
          <span>Fórum</span>
          <span class="ct-badge">novo</span>
        </a>
        -->
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
      .ct-wrap {
        display: flex;
        justify-content: center;
        margin: 0 auto 18px;
        max-width: 640px;
      }
      .ct-switch {
        display: inline-flex;
        gap: 4px;
        padding: 5px;
        background: #1e1f23;
        border: 1px solid #303136;
        border-radius: 12px;
        width: 100%;
      }
      .ct-tab {
        flex: 1;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 9px 18px;
        border-radius: 8px;
        font-family: 'Saira', sans-serif;
        font-size: 0.9rem;
        font-weight: 600;
        color: #9a9ba0;
        text-decoration: none;
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease;
        position: relative;
      }
      .ct-tab i {
        font-size: 0.95rem;
      }
      .ct-tab:hover {
        color: #fff;
        background: rgba(172, 40, 28, 0.12);
      }
      .ct-tab--active {
        color: #fff;
        background: #AC281C;
      }
      .ct-tab--active:hover {
        background: #AC281C;
      }
      .ct-badge {
        font-size: 0.6rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        padding: 2px 6px;
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.18);
        color: #fff;
      }
      .ct-tab--active .ct-badge {
        background: rgba(0, 0, 0, 0.25);
      }
    `,
  ],
})
export class CommunityTabsComponent {
  /** Reservado para futura parametrização; mantém API estável. */
  @Input() context: 'feed' | 'forum' = 'feed';
}
